export enum TenantIconNameEnum {
  binoculars,
  watchActive,
  stays,
  stays__active,
  stays__active__with_background,
  flights,
  flights__active,
  cars,
  cars__active,
  packages,
  packages__active,
  activities,
  activities__active,
  pricePrediction,
  predictionNormal,
  predictionWarning,
  predictionDanger,
  resetFilter,
  fareClassBasic,
  fareClassStandard,
  fareClassEnhanced,
  fareClassPremium,
  fareClassLuxury,
  avionCoin,
  timer,
  stays__bathroom,
  stays__bedSingle,
  stays__bedOther,
  stays__sofa,
  stays__tv,
  stays__cookingPot,
  stays__trees,
  stays__parking,
  stays__security,
  stays__cleaning,
  home,
  hotelBuilding,
  infoOutline,
  ticket,
  leftNavChevron,
  rightNavChevron,
  iteration,
  email,
  cancelCircle,
  questionCircle,
  travel,
  rating,
  offers,
  recentlySearched,
  disruptionAssistance,
  freeCancellation,
  dropOff,
  pickUp,
  smokingArea,
  westernStyle,
  circleChevronLeft,
  customerSupport,
  phone,
  alertOutline,
  seat,
  exchange,
  swap,
  pointsCreditCard,
  pointsShoppingCart,
  pointsStar,
  flightsTrips,
  hotelsTrips,
  carsTrips,
  luggageTrips,
  chevron,
  accessibility,
  checkBubble,
  offersPercent,
  priceTag,
  arrowRightAlt,
  wallet,
  mapPinFill,
  /** Bare plus and minus glyphs, as opposed to the circled `plus` / `minus`. */
  plusOutline,
  minusOutline,
  help,
  timesAlt,
}
